module.exports = __webpack_public_path__ + "static/media/confetti.bb386e2b.jpg";